window.mcb.forms.fields = window.mcb.forms.fields || {};
window.mcb.forms.fields.extensions = window.mcb.forms.fields.extensions || {};
window.mcb.forms.fields.extensions.hidden = function (parent) {
    const _thisField = parent;
    let _control = null;

    const render = function (target) {
        const hiddenWrapper = document.createElement('div');
        hiddenWrapper.id = _thisField.fieldGroupId;
        hiddenWrapper.classList.add(window.mcb.forms.constants.fields.classBase + _thisField.settings.type.toLowerCase());
        target.append(hiddenWrapper);

        _control = document.createElement('input');
        _control.id = _thisField.fieldValueControlId;
        _control.name = _thisField.alias;
        _control.dataset.fieldActuator = true;
        _control.type = 'hidden';
        _control.value = _thisField.settings.defaultValue;
        _control.dataset.dirty = true;

        hiddenWrapper.append(_control);

        return hiddenWrapper;
    };

    const getValue = function (allowValueFormatting = false) {
        return _control.value;
    };

    const setValue = function (value) {
        _control.value = value;
        return true;
    }

    return _ = {
        render: render,
        getValue: getValue,
        setValue: setValue
    };
};
